import { useQuery } from '@tanstack/react-query';
import { useClient } from '@/hooks/useClient';
import { useAuth } from '@/contexts/auth';

interface VendorHealthResponse {
  is_down_payment_not_available: boolean;
}

export interface DownPaymentValidationResult {
  isDownPaymentMisconfigured: boolean;
  missingPaymentMethods: string[];
  shouldShowBanner: boolean;
}

export const useDownPaymentValidation = (): DownPaymentValidationResult => {
  const { client } = useClient();
  const { session } = useAuth();

  const { data } = useQuery({
    queryKey: ['vendor-health'],

    queryFn: async () =>
      await client<VendorHealthResponse>('me/vendor/health', 'GET', {
        isAuthRequired: true,
        // Cinturón y tiradores: el gate de abajo ya evita el request cuando no hay
        // vendor, pero si la sesión llega incompleta cyclone devuelve 404 y ese
        // 404 le tiraba un "Resource not found." en inglés a alumnos de cursos.
        suppressNotFoundToast: true
      }),

    // El Layout monta este hook para CUALQUIER usuario autenticado. Un alumno de
    // curso no tiene vendor, así que el request salía sólo para cobrar un 404
    // cada 5 minutos — y desde Argentina cada viaje al origen en NYC cuesta
    // ~500 ms. Sin vendor no hay banner de seña que mostrar: no preguntamos.
    enabled: !!session?.vendor,

    retry: false,
    refetchOnWindowFocus: false,
    refetchInterval: 5 * 60 * 1000,
    staleTime: 2 * 60 * 1000
  });

  const hasDownPaymentIssues = data?.is_down_payment_not_available || false;

  return {
    isDownPaymentMisconfigured: hasDownPaymentIssues,
    missingPaymentMethods: [], // Backend now handles the logic, no need to specify methods
    shouldShowBanner: hasDownPaymentIssues
  };
};
